<template>
    <form-save 
        modelName="Categoria" 
        saveUrl="checklist-categories/" 
        :id="$route.params.id" 
        operation="put"
        backUrl="/checklist-categories"
        icon="fa-list-ul"
        ></form-save>
</template>


<script>
import FormSave from "./FormSave";
export default {
  components: {
    FormSave
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ChecklistCategory/Edit.vue